import { graphql } from 'src/gql'
import { EeocsQueryVariables, SortFindManyEeocInput } from 'src/gql/graphql'
import { GetTData } from 'src/gql/helpers'
import { useGraphQL } from 'src/hooks/useGraphQL'

const document = graphql(/* graphql */`
  query Eeocs($filter: FilterFindManyEeocInput, $sort: SortFindManyEeocInput) {
    cat {
      eeoc {
        many(filter: $filter, sort: $sort) {
          _id
          createdAt
          candidate
          _candidate {
            _id
            lastFirstName
          }
          signedOn
          status
          documentData
          voidReason
          voidedOn
        }
      }
    }
  }
`)

type TData = GetTData<typeof document>
export type Eeocs = NonNullable<NonNullable<NonNullable<NonNullable<TData>['cat']>['eeoc']>['many']>

const useEeocs = (filter: EeocsQueryVariables['filter']): Eeocs => {
  const { data } = useGraphQL(document, {
    filter,
    sort: SortFindManyEeocInput.CreatedatDesc
  })
  return data?.cat?.eeoc?.many ?? []
}

export { useEeocs, document as eeocsDocument }
